import React from 'react';

import { AUTH_MODES, getAuthMode } from '@/modules/auth/mode';

import { LegacyEditContactInfo } from './LegacyEditContactInfo';
import { ContactInfoEditor } from './v3';

interface IProps {
  onGoBack: () => void;
}

/**
 * V3 sessions change email and phone through OTP-confirmed identifier updates.
 * The legacy V6 tail keeps the old phone-only form until it is removed: a field
 * that was not editable there must not become editable.
 */
const EditContactInfo = ({ onGoBack }: IProps) =>
  getAuthMode() === AUTH_MODES.LEGACY ? (
    <LegacyEditContactInfo onGoBack={onGoBack} />
  ) : (
    <ContactInfoEditor onGoBack={onGoBack} />
  );

export { EditContactInfo };
